const hashtagRegex = /(\s|^)#(\p{L}|\d|_)+/gmu;
export {
  hashtagRegex
};
//# sourceMappingURL=const.js.map
